
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class WatermarkEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, config, layerIndex, globalHue, width, height, camX, camY, time } = pc;
        
        const text = config.parallaxWatermarkText || "HYPNOTIC";
        const fontSize = (config.parallaxWatermarkFontSize || 40) * (config.parallaxScale || 1.0);
        const opacity = config.parallaxWatermarkOpacity || 0.1;
        const repeatX = config.parallaxWatermarkRepeatX || 5;
        const repeatY = config.parallaxWatermarkRepeatY || 5;
        const angle = (config.parallaxWatermarkAngle || -45) * Math.PI / 180;
        const speed = (config.parallaxWatermarkSpeed || 0.5) * config.parallaxSpeed;
        const density = config.parallaxWatermarkDensity || 0.5;
        const fontFamily = config.parallaxWatermarkFontFamily || "Inter";
        const fontWeight = config.parallaxWatermarkFontWeight || "900";

        ctx.save();
        ctx.font = `${fontWeight} ${fontSize}px ${fontFamily}, sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        
        // Color logic override
        let color = pc.color;
        if (config.parallaxWatermarkUseBallColor) {
            color = `hsl(${globalHue}, 100%, 50%)`;
        }

        ctx.fillStyle = color;
        ctx.globalAlpha *= opacity;

        // Shadow controls
        if (config.parallaxWatermarkShadowBlur > 0) {
            ctx.shadowColor = config.parallaxWatermarkShadowColor || "rgba(0,0,0,0.5)";
            ctx.shadowBlur = config.parallaxWatermarkShadowBlur;
            ctx.shadowOffsetX = config.parallaxWatermarkShadowOffsetX || 0;
            ctx.shadowOffsetY = config.parallaxWatermarkShadowOffsetY || 0;
        }

        // Calculate scrolling offset
        const scrollX = (-camX * 0.1 * layerIndex) + (time * 50 * speed);
        const scrollY = (-camY * 0.1 * layerIndex);

        // Density affects spacing
        const spacingX = (width * 2) / (repeatX * density);
        const spacingY = (height * 2) / (repeatY * density);

        ctx.rotate(angle);

        const buffer = 2;
        for (let x = -repeatX - buffer; x <= repeatX + buffer; x++) {
            for (let y = -repeatY - buffer; y <= repeatY + buffer; y++) {
                const px = x * spacingX + (scrollX % spacingX);
                const py = y * spacingY + (scrollY % spacingY);
                ctx.fillText(text, px, py);
            }
        }

        ctx.restore();
    }
}
